<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" icon="el-icon-plus" @click='showAddDialog'>添加</el-button>

    </div>
    <el-table :data="list" v-loading="listLoading" fit border highlight-current-row style="width: 100%"  max-height="550">
      <el-table-column align="left" label="日期" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label=" 品牌名称" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.brandName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label=" 车系名称" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.seriesName }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" align="left" label="状态" width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status | statusDisplay }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
          <el-button type="warning" size="mini" @click="toDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog title="添加数据" :visible.sync="newDialogVisible" width="30%">
      <el-form ref="newForm" :model="newData" :rules="newFormRules" label-position="right" label-width="120px">
        <el-form-item label="品牌名称" prop="brandName">
          <el-input style="width: 200px" v-model="newData.brandName" placeholder="品牌名称"></el-input>
        </el-form-item>
        <el-form-item label="车系名称" prop="seriesName">
          <el-input style="width: 200px" v-model="newData.seriesName" placeholder="车系名称"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="newDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doAdd">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑数据" :visible.sync="editDialogVisible" width="30%">
      <el-form ref="editForm" :model="editData" :rules="newFormRules" label-position="right" label-width="120px">
        <el-form-item label="品牌名称" prop="brandName">
          <el-input style="width: 200px" v-model="editData.brandName"></el-input>
        </el-form-item>
        <el-form-item label="车系名称" prop="seriesName">
          <el-input style="width: 200px" v-model="editData.seriesName"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select style="width: 200px" class="filter-item" v-model="editData.status">
            <el-option label="有效" :value="0">
            </el-option>
            <el-option label="冻结" :value="-1">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doUpdate">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'SystemCompetitionList',
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      roles: [],

      newDialogVisible: false,
      newData: {
        brandName: '',
        seriesName: ''
      },

      editDialogVisible: false,
      editData: {
        id: 0,
        brandName: '',
        seriesName: '',
        status: 0
      },

      newFormRules: {
        brandName: [{
          required: true,
          message: '请输入类品牌名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 30,
          message: '长度应在1-30位',
          trigger: 'blur'
        }],
        seriesName: [{
          required: true,
          message: '请输入车系名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 30,
          message: '长度应在1-30位',
          trigger: 'blur'
        }]
      }
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        0: 'success',
        1: 'info'
      }
      return statusMap[status]
    },
    statusDisplay(status) {
      const statusMap = {
        '0': ' 有效',
        '-1': '冻结'
      }
      return statusMap[status]
    }
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  activated() {
    if (this.$route.meta.hasOwnProperty('redraw') && this.$route.meta.redraw) {
      this.doReset()
      this.$route.meta.redraw = false
    }
    if (this.$route.meta.hasOwnProperty('refresh') && this.$route.meta.refresh) {
      this.getList()
      this.$route.meta.refresh = false
    }
  },
  created() {
    this.doReset()
  },
  methods: {
    doReset() {
      this.list = null
      this.total = 0
      this.listLoading = true
      this.listQuery = {
        page: 1,
        limit: 10,
        brandName: '',
        seriesName: ''
      }
      this.doSearch()
    },
    doSearch() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.listLoading = true
      var parent = this
      this.$httpAuth
        .post('/v1/backendCompetitionRpc/list', {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit
        })
        .then(function (response) {
          parent.listLoading = false
          parent.list = response.data.data
          parent.total = response.data.total
        })
        .catch(() => {
          parent.listLoading = false
        })
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    toDelete(id) {
      this.$confirm('是否删除该数据?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var parent = this
        this.$httpAuth
          .post('/v1/backendCompetitionRpc/delete', {
            id: id
          })
          .then(function (response) {
            parent.$message({
              message: '删除成功',
              type: 'success'
            })
            parent.getList()
          })
      })
    },
    showAddDialog() {
      this.newDialogVisible = true
      this.newData = {
        brandName: '',
        seriesName: ''
      }
      if (this.$refs['newForm']) {
        this.$refs['newForm'].resetFields()
      }
    },
    doAdd() {
      this.$refs['newForm'].validate((valid) => {
        if (valid) {
          var parent = this
          this.$httpAuth
            .post('/v1/backendCompetitionRpc/add', {
              'brandName': this.newData.brandName,
              'seriesName': this.newData.seriesName,
              'status': 0
            })
            .then(function (response) {
              parent.getList()
              parent.newDialogVisible = false
            })
        }
      })
    },
    showEditDialog(row) {
      this.editData = {
        id: row.id,
        brandName: row.brandName,
        seriesName: row.seriesName,
        status: row.status
      }
      this.editDialogVisible = true
      if (this.$refs['editForm']) {
        this.$refs['editForm'].resetFields()
      }
    },
    doUpdate() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          var parent = this
          this.$httpAuth
            .post('/v1/backendCompetitionRpc/update', {
              'id': this.editData.id,
              'brandName': this.editData.brandName,
              'seriesName': this.editData.seriesName,
              'status': this.editData.status
            })
            .then(function (response) {
              parent.getList()
              parent.editDialogVisible = false
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>
